import React, { useEffect, useState } from 'react'
import { GetUsersByUserGroupOutput } from '../../../../Adaptor/TUBSIS/controllers/UserGroups/models/getUserGroupModels'
import { Button, Col, FloatingLabel, Form, FormControl, Modal, Row } from 'react-bootstrap';
import { createAppointment } from '../../../../Adaptor/TUBSIS/controllers/Appointments/Appointments';
import { getUsersByUserGroup } from '../../../../Adaptor/TUBSIS/controllers/UserGroups/UserGroups';
import moment from 'moment';

type Props = {propAppointmentStartDate: Date | null}

const AppointmentCreateWithExistUser : React.FC<Props> = ({ propAppointmentStartDate }) => {

    const [patientList, setPatientList] = useState<GetUsersByUserGroupOutput[] | null>(null)

    //bu kodu yazan eleman kör oldu
    useEffect(() => {
      getUsersByUserGroup(1) //tubsis
        .then((response1) => {
          getUsersByUserGroup(2) //polsis
            .then((response2) => {
              getUsersByUserGroup(6) //sbp (nosis:))
                .then((response3) => {
                  const combinedData: GetUsersByUserGroupOutput[] = []

                  if (response1 && response1.data) {
                    combinedData.push(...response1.data)
                  }

                  if (response2 && response2.data) {
                    combinedData.push(...response2.data)
                  }

                  if (response3 && response3.data) {
                    combinedData.push(...response3.data)
                  }
                  setFilteredPatientList(combinedData)
                  setPatientList(combinedData)
                })
                .catch((error) => {
                  console.log(error)
                })
            })
            .catch((error) => {
              console.log(error)
            })
        })
        .catch((error) => {
          console.log(error)
        })
    }, [])

    const [showModal, setShowModal] = useState(false);
    
    const clearForm = () => {
        
        setSelectedExpertId(null)
        setSelectedPatientId(null)
        
        //console.log("date", propAppointmentStartDate)
        if (propAppointmentStartDate && propAppointmentStartDate !== null){
            const editedPropAppointmentStartDate = new Date(propAppointmentStartDate)

            setAppointmentStartDate(new Date(editedPropAppointmentStartDate))
            
            let propAppointmentEndDate = new Date(editedPropAppointmentStartDate)
            propAppointmentEndDate.setMinutes(propAppointmentEndDate.getMinutes() + 15)//randevu süresi 15 dk

            setAppointmentEndDate(new Date(propAppointmentEndDate))

            console.log("date", propAppointmentStartDate, appointmentEndDate)

            setIsAppointmentStartDateReadOnly(true)
        }else{
            setAppointmentStartDate(null)
            setAppointmentEndDate(null)
        }
    }

    const openModal = () => {
        clearForm()
        setShowModal(true);
    };

    const closeModal = () => {
        clearForm()
        setShowModal(false);
        // window.location.reload();
    };
   
    const [selectedExpertId, setSelectedExpertId] = useState<number | null>(null);
    const [selectedPatientId, setSelectedPatientId] = useState<number | null>(null)
    const [appointmentStartDate, setAppointmentStartDate] = useState<Date | null>(null);
    const [isAppointmentStartDateReadOnly, setIsAppointmentStartDateReadOnly] = useState<boolean>(false);
    const [appointmentEndDate, setAppointmentEndDate] = useState<Date | null>(null);
    const [isFirstAppointment, setIsFirstAppointment] = useState<boolean>(true);

    // Uzman seçimi yapıldığında bu fonksiyon çalışacak
    const handleExpertChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const expertId = parseInt(e.target.value);
        if (expertId && expertId > 0){
            setSelectedExpertId(expertId);
        }
        else{
            setSelectedExpertId(null);
        }
    };

    // Danışan seçimi yapıldığında bu fonksiyon çalışacak
    const handlePatientChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const patientId = parseInt(e.target.value);
        if (patientId && patientId > 0){
            setSelectedPatientId(patientId);
        }
        else{
            setSelectedPatientId(null);
        }
    };

    const parseAppointmentDateStringToDate = (dateString: string): Date | null => {
        const dateRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/;
        const match = dateString.match(dateRegex);
        if (!match) return null;
    
        const year = parseInt(match[1]);
        const month = parseInt(match[2]) - 1;
        const day = parseInt(match[3]);
        const hour = parseInt(match[4]);
        const minute = parseInt(match[5]);
    
        const parsedDate = new Date(year, month, day, hour, minute);

        // Oluşturulan tarihin geçerli olup olmadığını kontrol et
        const currentDate = new Date();
        if (parsedDate <= currentDate) return null;

        return parsedDate;
    };

    const [isValidStartDate, setIsValidStartDate] = useState<boolean>(true);
    const [isValidEndDate, setIsValidEndDate] = useState<boolean>(true);

    const handleItemChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, checked, type } = e.target;
        if (name === 'appointmentStartDate') {
            const parsedDate = parseAppointmentDateStringToDate(value)
            
            setAppointmentStartDate(parsedDate);
            
            // console.log("p1",parsedDate)
            // console.log("p2",appointmentStartDate)

            setIsValidStartDate(parsedDate !== null);
            // console.log("p3",appointmentStartDate)
        } else if (name === 'appointmentEndDate') {
            const parsedDate = parseAppointmentDateStringToDate(value)
            setAppointmentEndDate(parsedDate);
            setIsValidEndDate(parsedDate !== null);
        } 
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement | HTMLButtonElement>) => {
        e.preventDefault();

        const possibleMinuteList: number[] = [0, 15, 30, 45];

        var startHour = appointmentStartDate?.getHours();
        var startMinute = appointmentStartDate?.getMinutes();

        if (!isValidStartDate || appointmentStartDate === null || startHour === null || (startHour??1) < 9 || 
            (startHour??23)>15 ||startHour === 12 || possibleMinuteList.filter(p=>p === (startMinute??1)) === null) {
            alert("Randevu saatleri 9:00 - 11:45 ve 13:00 - 15:45 arasındadır. Her randevu 15 dk sürmektedir. Lütfen uygun bir giriş yapınız.")
            return;
        }

        // if (selectedExpertId === null || selectedExpertId <= 0 || isNaN(selectedExpertId)) {
        //     // Eğer uzman seçilmemişse, hata mesajı göster
        //     alert("Lütfen bir uzman seçiniz.");
        //     return;
        // }

        if (selectedPatientId === null || selectedPatientId <= 0 || isNaN(selectedPatientId)) {
            // Eğer danışan seçilmemişse, hata mesajı göster
            alert("Lütfen bir danışan seçiniz.");
            return;
        }
        
        let parsedAppointmentStartDate = new Date(appointmentStartDate)
        let parsedAppointmentEndDate = new Date(appointmentStartDate)

        parsedAppointmentEndDate.setMinutes(parsedAppointmentEndDate.getMinutes() + 15)//randevu süresi 15 dk

        parsedAppointmentStartDate.setHours(parsedAppointmentStartDate.getHours() + 3)//utc kaynaklı düzeltme
        parsedAppointmentEndDate.setHours(parsedAppointmentEndDate.getHours() + 3)

        const requestModel = {
            ExpertId: 2,//bütün randevular admin kullanıcısına atanacak
            PatientId: selectedPatientId,
            AppointmentStartDate: new Date(parsedAppointmentStartDate),
            AppointmentEndDate: new Date(parsedAppointmentEndDate),
            IsFirstAppointment: isFirstAppointment??true
        };

        const response = await createAppointment(requestModel);

        if (response.success){
            alert(response.message); 
            window.location.reload();
        } else {
            alert(response.message);
            return;
        }

        closeModal(); // Modalı kapat
    };

    const [filteredPatientList, setFilteredPatientList] = useState<GetUsersByUserGroupOutput[]>([]); // Filtrelenmiş hasta listesi
    const [searchTerm, setSearchTerm] = useState<string>(''); // Arama terimi

    // Arama işlevi
    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const term = event.target.value;
        setSearchTerm(term); // Arama terimini güncelle

        // Arama terimine göre filtreleme yap
        const filteredList = patientList?.filter(patient => 
            patient.fullName.toLowerCase().includes(term.toLowerCase()) ||
            patient.citizenId.toString().toLowerCase().includes(term.toLowerCase()) // Arama terimi hastanın adında geçiyor mu?
        );
        setFilteredPatientList(filteredList??[]); // Filtrelenmiş hasta listesini güncelle
    };

    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsFirstAppointment(event.target.id === 'isFirstAppointment'); // Radio buton id'sine göre true veya false setleme
    };

    return (
      //<div>AppointmentCreateWithUser</div>
        <div className='text-end mt-2' >
            <input type='button' className='btn btn-primary' value={"OLUŞTUR"} onClick={openModal} />
            <Modal show={showModal} onHide={closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Sistemde Kayıtlı Bir Danışan İçin Randevu Oluştur</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        {/* <FloatingLabel className='mb-3' controlId="expertId" key={-1} label="Uzman Seçiniz">
                            <Form.Select name="expertId" onChange={handleExpertChange}>
                                <option value="">Uzman Seçiniz</option>
                                {experts.map(expert => (
                                    <option key={expert.userId} value={expert.userId}>
                                        {expert.fullName}
                                    </option>
                                ))}
                            </Form.Select>
                        </FloatingLabel>       */}

                        <FloatingLabel className='mb-3' controlId="patientId" key={1} label="TC Kimlik No ile Danışan Ara...">
                            <Form.Control
                                type="text"
                                value={searchTerm}
                                onChange={handleSearch}/>
                        </FloatingLabel>
                        <FloatingLabel className='mb-3' controlId="patientId" key={2} label="Danışan Seçiniz">
                            <Form.Select name="patientId" onChange={handlePatientChange}>
                                <option value="">Danışan Seçiniz</option>
                                {filteredPatientList?.map(patient => (
                                    <option key={patient.userId} value={patient.userId}>
                                        {patient.fullName}
                                    </option>
                                ))}
                            </Form.Select>
                        </FloatingLabel>      

                        {/* <Row className="mb-3"> */}
                            {/* <Form.Group as={Col}> */}
                                <FloatingLabel controlId="appointmentStartDate" label="Randevu Başlangıç Tarihi">
                                    <FormControl 
                                        type="datetime-local" 
                                        name="appointmentStartDate"
                                        isInvalid={!isValidStartDate}
                                        value={moment(appointmentStartDate).format('YYYY-MM-DDTHH:mm')}
                                        readOnly = {isAppointmentStartDateReadOnly}
                                        //disabled = {appointmentStartDate ? true : false}
                                        onChange={handleItemChange} />
                                    <Form.Control.Feedback type="invalid">
                                        Geçerli bir tarih ve saat girin.
                                    </Form.Control.Feedback>
                                </FloatingLabel>
                            {/* </Form.Group> */}

                            {/* <Form.Group as={Col}>
                                <FloatingLabel controlId="appointmentEndDate" label="Randevu Bitiş Tarihi">
                                    <FormControl 
                                        type="datetime-local" 
                                        name="appointmentEndDate" 
                                        isInvalid={!isValidEndDate}
                                        onChange={handleItemChange} />
                                    <Form.Control.Feedback type="invalid">
                                        Geçerli bir tarih ve saat girin.
                                    </Form.Control.Feedback>
                                </FloatingLabel>
                            </Form.Group>
                        </Row> */}

                        {/* <Form.Check
                            type="checkbox"
                            style={{marginTop:"10px"}}
                            id="isFirstAppointment"
                            label="İlk Randevu Mu?"
                            name="isFirstAppointment"
                            defaultChecked
                            onChange={handleItemChange}
                        /> */}

                        <Row className="mt-6">
                            <Form.Group as={Col}>
                                <Form.Check
                                    type="radio"
                                    id="isFirstAppointment"
                                    name="flexRadioDefault"
                                    label={<span style={{ fontWeight: 'bold', color: isFirstAppointment ? '#04c8c8' : '#b5b5c3' }}>İLK RANDEVU</span>} 
                                    className="form-check-custom form-check-input-xl" 
                                    checked={isFirstAppointment}
                                    onChange={handleRadioChange}
                                />

                                <Form.Check
                                    type="radio"
                                    id="isNotFirstAppointment"
                                    name="flexRadioDefault"
                                    label={<span style={{ fontWeight: 'bold', color: !isFirstAppointment ? '#04c8c8' : '#b5b5c3' }}>KONTROL RANDEVUSU</span>} 
                                    className="form-check-custom mt-2 form-check-input-xl"
                                    checked={!isFirstAppointment}
                                    onChange={handleRadioChange}
                                />                            
                            </Form.Group>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeModal}>
                        Kapat
                    </Button>
                    <Button variant="primary" onClick={handleSubmit}>
                        Kaydet
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default (AppointmentCreateWithExistUser)